import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Form, Row, Col } from "react-bootstrap";
import { zodResolver } from "@hookform/resolvers/zod";

import FormField from "../../../ui/FormField";
import ErrorMessage from "../../../ui/ErrorMessage";
import formEditStroskovnoMestoSchema from "../../../../config/formEditStroskovnoMesto";

import { useAddStroskovnaMestaClanice } from "../../../../services/ProjectDetails/financeAPI";

const AddStroskovnoMestoForm = ({ clanicaID, setIsAdding }) => {
  const { id } = useParams();
  const schema = useMemo(() => formEditStroskovnoMestoSchema, []);

  const {
    mutate: addStroskovnoMesto,
    isPending: isPendingAdd,
    isError,
    error,
    reset: resetMutationError,
  } = useAddStroskovnaMestaClanice(id);

  const {
    handleSubmit,
    register,
    formState: { errors, isDirty },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      stroskovnoMesto: "",
      stroskovniNosilec: "",
    },
  });

  const onSubmit = (data) => {
    const payload = {
      clanicaID,
      stroskovnoMesto: data.stroskovnoMesto,
      stroskovniNosilec: data.stroskovniNosilec,
    };

    addStroskovnoMesto(payload, {
      onSuccess: () => {
        setIsAdding(false);
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="pb-3">
      <Row>
        <Col md={5}>
          <FormField
            label="Stroškovno mesto"
            showLabel={false}
            formControlType="text"
            register={register("stroskovnoMesto")}
            validationError={errors.stroskovnoMesto?.message}
          />
        </Col>
        <Col md={5}>
          <FormField
            label="Stroškovni nosilec"
            showLabel={false}
            formControlType="text"
            register={register("stroskovniNosilec")}
            validationError={errors.stroskovniNosilec?.message}
          />
        </Col>
        <Col md={2} className="d-flex align-items-center gap-2 mt-3">
          <button
            type="submit"
            className="btn btn-sm btn-primary"
            disabled={!isDirty || isPendingAdd}
          >
            {isPendingAdd ? "Shranjevanje..." : "Shrani"}
          </button>
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            onClick={() => setIsAdding(false)}
          >
            Prekliči
          </button>
        </Col>
      </Row>
      {isError && <ErrorMessage message={error.message} />}
    </Form>
  );
};

export default AddStroskovnoMestoForm;
